import type { ReactNode } from 'react'
import { Button } from '@highlight/ui'
import { twMerge } from 'tailwind-merge'

/**
 * A strip under the top bar carrying one fact and one thing to do about it.
 *
 * Sits on the panel's unified surface rather than on a fill of its own: the
 * pre-2.0 recipe was a `bg-element-active` slab with a `border-t`, which read as
 * a separate piece of chrome bolted under the header. Here it's a hairline and a
 * barely-lifted tint, so the header still reads as one surface from the top bar
 * down into the body — the same treatment sections and rows got.
 */
export function SidepanelBanner({
  className,
  icon,
  message,
  action,
  onAction,
}: {
  className?: string
  icon: ReactNode
  message: string
  action: string
  onAction: () => void
}) {
  return (
    <div
      className={twMerge(
        'bg-element text-foreground type-ui-sm flex w-full items-center justify-between gap-2 border-t px-3 py-2 font-medium',
        className,
      )}
    >
      <div className="flex min-w-0 items-center gap-2">
        {icon}
        <span className="min-w-0 flex-1 truncate">{message}</span>
      </div>
      <Button className="shrink-0" variant="ghost" onClick={onAction}>
        {action}
      </Button>
    </div>
  )
}
